// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3953515b","821":"9cc8cfcf"}[chunkId] + ".chunk.js";
};